var $c692b35795a2e841$exports = {};
$c692b35795a2e841$exports = {
    "colorFormat": `Format boje`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$c692b35795a2e841$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
